import { authSlice } from '../redux/auth/slices';
import { dealerSlice } from '../redux/dealers/slices';
import { globalConfigurationsSlice } from '../redux/globalConfigurations/slices';
import { useAppDispatch } from '../redux/store';

export const logout = (dispatch: ReturnType<typeof useAppDispatch>) => {
  dispatch(authSlice.actions.logout());
  dispatch(dealerSlice.actions.clearDealer());
  dispatch(globalConfigurationsSlice.actions.clear());
};
